import { defineComponent, PropType } from "vue";

interface ExhibitionItem {
  title: string;
  subtitle: string;
  introduction: string;
  date: string;
  date2?: string;
  link?: string;
}
export default defineComponent({
  props: {
    showArchived: { type: Boolean, default: true },
    items: { type: Array as PropType<ExhibitionItem[]>, required: false },
    archiveTitle: { type: String, required: false },
    archiveText: { type: String, required: false },
    archivedItems: {
      type: Array as PropType<ExhibitionItem[]>,
      required: false,
    },
    backgroundColor: { type: String, required: false },
  },
});
